


















import Vue from 'vue'
import moment from 'moment-timezone'
import { withSingularOrPluralLabel } from '@/utils/labels'
export default Vue.extend({
  props: {
    periodOptions: {
      type: Array,
      default: () => [],
    },
    startTimestamp: {
      type: Number,
      required: true,
    },
    endTimestamp: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    periodLabel() {
      const defaultText = 'View:'
      if (this.startTimestamp <= 1) {
        return `${defaultText} ALL`
      }
      const end = moment(this.endTimestamp).add(1, 'day')
      const start = moment(this.startTimestamp)
      const diff = end.diff(start, 'weeks')
      const weeksLabel = `${defaultText} LAST ${withSingularOrPluralLabel(diff, 'WEEK', 'WEEKS')}`
      return this.$vuetify.breakpoint.name === 'xs'
        ? weeksLabel
        : `${weeksLabel} (${this.startTimestampLabel} - ${this.endTimestampLabel})`
    },
    startTimestampLabel() {
      return moment(this.startTimestamp).format('MMM D')
    },
    endTimestampLabel() {
      return moment(this.endTimestamp).format('MMM D')
    },
  },
})
